function timelineItem(theme, ownerState) {
  const { breakpoints, borders } = theme;
  const { isLeft, firstItem, lastItems, todayItem } = ownerState;

  const { borderWidth, borderColor } = borders;

  return {
    position: "relative",
    display: "flex",
    width: "100%",
    pt: firstItem ? "0" : "10px",
    pb: lastItems.page ? "0" : "10px",
    "&:after": {
      content: !todayItem && !lastItems.page && !lastItems.month ? "''" : "none",
      position: "absolute",
      top: firstItem ? "30px" : "42px",
      height: "100%",
      borderRight: `${borderWidth[2]} solid ${borderColor}`,
      left: { xxs: "12px", sm: "18px" }
    }
  };
}

function timelineItemIcon(theme, ownerState) {
  const { palette, typography, functions } = theme;
  const { color, firstItem, hasSelected } = ownerState;

  const { gradients, transparent } = palette;
  const { size, fontWeightMedium } = typography;
  const { linearGradient } = functions;

  return {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: !hasSelected ? "translate(-50%, -50%)" : "translate(-54.5%, -50%)",
    fontSize: size.xl,
    fontWeight: fontWeightMedium,
    zIndex: 1,
    backgroundImage: linearGradient(gradients[color].main, gradients[color].state),
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: transparent.text,
  };
}

export { timelineItem, timelineItemIcon };
